<template>
  <div class="wps-template-list">
    <p @click="$refs.notice.show()">
      温馨提示：模板领取后保存在WPS云文档中
      <img src="./images/icon-important.png" alt="">
    </p>
    <div class="wps-template-list-main" v-for="(item, i) in directory" :key="i">
      <Head>{{item.name}}</Head>
      <Item class="item" v-for="(itm, index) in item.list"
            :key="index"
            :item="itm"
            :fileName="itm.name"
            :lastModified="itm.lastModified"
            @toPage="toPage"></Item>
    </div>
    <Notice ref="notice" class="notice">
      <div class="notice-main">
        <h1>模板领取说明</h1>
        <ol class="notice-main-lists">
          <li>模板<span class="stress">永久有效</span>，用户无需一个个下载，在需要的时候领取即可；</li>
          <li>点击对应分类后可看到对应模板，<span class="stress">点击领取</span>即可保存到<span class="stress">WPS云文档</span>中;</li>
          <li>可在WPS云文档-<span class="stress">微课模板</span>进行查看所领取的模板；</li>
        </ol>
        <UIButton class="notice-main-btn" @click="closeBubble" width="220">我知道了</UIButton>
      </div>
    </Notice>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../../modules/WpsTemplate/list'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Head from '../../components/WpsTemplate/Head'
import Item from '../../components/WpsTemplate/Item'
import Notice from "../../components/Notice"
import UIButton from "../../components/UI/Button"
import Cookie from 'js-cookie'
export default {
  data () {
    return {
      isBubbleShow: false
    }
  },
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    toPage (fileId, fileName) {
      this.$router.push({
        path: '/wps-template/detail',
        query: {
          fileId,
          fileName
        }
      })
    },
    closeBubble () {
      this.$refs.notice.close()
      Cookie.set('isTemplateBubbleShow', true, { expires: 1 })
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    this.init()
  },
  mounted () {
    if (!Cookie.get('isTemplateBubbleShow')) {
      this.$refs.notice.show()
    }
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    Head,
    Item,
    Notice,
    UIButton
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.wps-template-list {
  /*padding: 0 rem(30);*/
  > p {
    height: rem(60);
    line-height: rem(60);
    color: #C19671;
    font-size: rem(24);
    background-color: #FFF7EB;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: rem(25);
    }
  }
  &-main {
    margin-bottom: rem(20);
    background-color: #fff;
  }
  .item {
    &:last-child {
      border: none;
    }
  }
  .stress {
    color: #F69000;
  }
  .notice {
    &-main {
      padding: rem(40) rem(30);
      line-height: 1.4;
      &-btn {
        margin: auto;
        font-weight: bold;
      }
      h1 {
        font-size: rem(36);
        font-weight: bolder;
        margin-bottom: rem(40);
      }
      &-lists, li {
        list-style: decimal;
        text-align: justify;
        margin: auto;
        width: 95%;
        color: #999999;
        font-size: rem(28);
        margin-bottom: rem(28);
      }
    }
  }
}
</style>
